import React from 'react';
import { Card } from './ui';
import { Star, XCircle } from 'lucide-react';
export function Testimonials() {
  return <section className="py-10 bg-slate-900/50 border-y border-slate-800" data-id="element-38" data-mp="3mvbz6o9t1kbd">
      <div className="max-w-6xl mx-auto px-4" data-id="element-39" data-mp="38x5de6i4ras2">
        <div className="flex flex-wrap justify-center gap-6 md:gap-14 text-center mt-[22px] mb-[22px]" data-id="element-40" data-mp="38wce1qli3njy">
          <div data-id="element-41" data-mp="3dtvu8w1reaej">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-42" data-mp="3dxjmzszdqss7">6</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-43" data-mp="2z59ewuc4tinb">Tomos completos</p>
          </div>
          <div data-id="element-44" data-mp="33yu3xwvqz2ad">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-45" data-mp="33zdm9epb7sox">5</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-46" data-mp="2q7pajciz368h">Bonos exclusivos</p>
          </div>
          <div data-id="element-47" data-mp="2u7zfqmyxxsma">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-48" data-mp="2u5d86nc1vd42">⚡</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-49" data-mp="2g99kzdzlg513">Acceso inmediato</p>
          </div>
          <div data-id="element-50" data-mp="2l6hyh19srkw0">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-51" data-mp="2l94610wou0e8">🥦</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-52" data-mp="2mninber4jwow">Recetas familiares</p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-53" data-mp="2hrv1n9buplo5">
          <Card className="bg-slate-900" data-id="element-54" data-mp="2vps0kcds245z">
            <div className="flex gap-1 mb-4" data-id="element-55" data-mp="2vnfjs2jr9zui">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-400 text-brand-400" data-id="element-56" data-mp="2qr89jxkbu26r" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-57" data-mp="22yi13ybmu118">
              "Mi hijo dejaba de comer cuando veía cebolla. Hoy come las hamburguesas completas y ni se da cuenta."
            </p>
            <div className="flex items-center gap-3" data-id="element-58" data-mp="2csqsgioxfnxt">
              <div className="w-10 h-10 rounded-full bg-brand-900 flex items-center justify-center text-brand-400 font-bold" data-id="element-59" data-mp="27zp7pu21gu6b">CG</div>
              <div data-id="element-60" data-mp="1k8juznreai08">
                <p className="font-bold text-white" data-id="element-61" data-mp="1k80b41i6pjjk">Carolina G.</p>
                <p className="text-xs text-slate-500" data-id="element-62" data-mp="1faqqcz5qpw22">Córdoba</p>
              </div>
            </div>
          </Card>

          <Card className="bg-slate-900" data-id="element-63" data-mp="3fd9ixpbe53go">
            <div className="flex gap-1 mb-4" data-id="element-64" data-mp="3kc2u3b37gido">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-400 text-brand-400" data-id="element-65" data-mp="3p3kthupkyawj" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-66" data-mp="3u2p66vbpqqrm">
              "Antes cocinaba dos comidas distintas todos los días. Ahora preparo una sola para toda la familia."
            </p>
            <div className="flex items-center gap-3" data-id="element-67" data-mp="31d8fq37nljy1">
              <div className="w-10 h-10 rounded-full bg-brand-900 flex items-center justify-center text-brand-400 font-bold" data-id="element-68" data-mp="31e0bpf55xjou">VP</div>
              <div data-id="element-69" data-mp="3ae6m2s5ke3js">
                <p className="font-bold text-white" data-id="element-70" data-mp="3aeoqic2dro2s">Verónica P.</p>
                <p className="text-xs text-slate-500" data-id="element-71" data-mp="lmm8niebeih0">Rosario</p>
              </div>
            </div>
          </Card>

          <Card className="bg-slate-900" data-id="element-72" data-mp="pnxst8ef6bht">
            <div className="flex gap-1 mb-4" data-id="element-73" data-mp="pmmkqwdxyhkw">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-400 text-brand-400" data-id="element-74" data-mp="2a4ylawve5vmw" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-75" data-mp="265g8kodq4qv5">
              "Lo que más me ayudó fue aprender cómo integrar las verduras sin arruinar la textura. Los almuerzos dejaron de ser una pelea."
            </p>
            <div className="flex items-center gap-3" data-id="element-76" data-mp="1wcr082dgzt41">
              <div className="w-10 h-10 rounded-full bg-brand-900 flex items-center justify-center text-brand-400 font-bold" data-id="element-77" data-mp="1rgtipsqh0gpo">MS</div>
              <div data-id="element-78" data-mp="1mfckk4zdf8cs">
                <p className="font-bold text-white" data-id="element-79" data-mp="1mj0bqxhcfioc">Marina S.</p>
                <p className="text-xs text-slate-500" data-id="element-80" data-mp="1iflwi918b6by">Buenos Aires</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}
export function Problem() {
  return <section className="py-12 px-4" data-id="element-81" data-mp="3csbt4yizetn1">
      <div className="max-w-3xl mx-auto" data-id="element-82" data-mp="37u9xzf8a73v7">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-white mb-5" data-id="element-83" data-mp="37vbkqgyntesr">
          ¿Cuántas comidas más van a terminar en discusión?
        </h2>

        <p className="text-slate-300 text-center text-[16px] mt-[11px] mb-[11px]" data-id="element-84" data-mp="29hxo3itghrph">
          Querés que coman mejor. Pero apenas ven un trocito de cebolla, zanahoria o brócoli, cierran la boca y el almuerzo se convierte en una negociación.
        </p>

        <p className="text-lg font-bold text-center text-brand-400 mb-6" data-id="element-85" data-mp="20fy54kyvsdjw">
          No es que no quieran comer. Es que ven la verdura.
        </p>

        <Card className="bg-slate-900/80 border-red-900/30 mb-6" data-id="element-86" data-mp="1qj1vud15rnea">
          <ul className="space-y-3" data-id="element-87" data-mp="1qlemrfow983h">
            {['Tu hijo deja de comer en el momento en que ve verduras en el plato', 'Terminás preparando dos comidas distintas para la misma mesa', 'Siempre comen lo mismo porque es lo único que aceptan', 'Sentís culpa porque sabés que comen muy pocas verduras', 'Cada comida termina en discusión, reto o plato lleno en la mesada', 'No sabés cómo incorporar verduras sin que las detecten al primer bocado'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-88" data-mp="j98yqra57y65" data-mpi={i}>
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-89" data-mp="y4ye46ktpd1w" />
                <span className="text-slate-300 text-lg" data-id="element-90" data-mp="y2vcsqe7zxhv">{item}</span>
              </li>)}
          </ul>
        </Card>

        <h3 className="text-2xl md:text-3xl font-bold text-center text-white" data-id="element-91" data-mp="175ecj1mpltzw">
          ¿Y si comieran verduras sin siquiera notarlo?
        </h3>
      </div>
    </section>;
}